import MapPage from './Map';
import DataFilesList from './DataFiles/DataFilesList';
import DataFilesAdd from './DataFiles/DataFilesAdd';
import DataFilesEdit from './DataFiles/DataFilesEdit';
import DataSharingRequestList from './DataSharingRequest/DataSharingRequestList';
import DataSharingAdd from './DataSharingRequest/DataSharingAdd';
import DataSharingEdit from './DataSharingRequest/DataSharingEdit';
import ProfileEdit from './Profile/ProfileEdit';
import './index.css';
export {
  MapPage,
  DataFilesList,
  DataFilesAdd,
  DataFilesEdit,
  DataSharingRequestList,
  DataSharingAdd,
  DataSharingEdit,
  ProfileEdit
}